import React from "react";

const initiatives = [
  {
    title: "Literacy & Education",
    description:
      "Conducting educational campaigns and distributing learning materials and stationery.",
  },
  {
    title: "Hunger Eradication",
    description:
      "Running food distribution and nourishment drives for those in need, including steady support to affected areas.",
  },
  {
    title: "Healthcare",
    description: "Organizing variety of drives including wellness drives.",
  },
  {
    title: "Child Development",
    description:
      "Supporting education, creativity, values, and overall growth of underprivileged children.",
  },
  {
    title: "Women Empowerment",
    description:
      "Driving awareness and skill development initiatives for women’s independence, dignity, defence, health.",
  },
  {
    title: "Environmental Action",
    description:
      "Leading cleanliness and plantation drives while encouraging personal growth through interactive sessions and workshops.",
  },
];

const InitiativeCards = () => {
  return (
    <section className="py-12 px-4 sm:px-8 lg:px-16 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
            What do we do
          </h1>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {initiatives.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 border border-gray-200 hover:shadow-xl transition-shadow duration-300"
            >
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {item.title}
              </h3>
              <p className="text-gray-700">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InitiativeCards;
